import { useMutation } from '@tanstack/react-query'

import { apiClient, CreateAssistantChatMessageFeedbackPayload } from 'lib/apiClient'

interface IAssistantChatMessagesFeedbackActionsHook {
  createAssistantChatMessageFeedback: (
    payload: CreateAssistantChatMessageFeedbackPayload,
  ) => Promise<{
    assistantTextGenerationId: string
  }>
  isLoading: boolean
  isError: boolean
}

export function useAssistantChatMessagesFeedbackActions(): IAssistantChatMessagesFeedbackActionsHook {
  const {
    mutateAsync: createAssistantChatMessageFeedback,
    isPending,
    isError,
  } = useMutation({
    mutationFn: (payload: CreateAssistantChatMessageFeedbackPayload) =>
      apiClient.createAssistantMessageFeedback(payload),
    retry: false,
  })

  return {
    createAssistantChatMessageFeedback,
    isLoading: isPending,
    isError,
  }
}
